import React from "react";
import { css, Theme, useTheme } from "@emotion/react";

type Props = {
    text: string
};

const ItemQuantityText: React.FC<Props> = ({ text }) => {
    const theme: Theme = useTheme();

    const style = css`
        margin-right: 21px;
        font-size: 24px;
        line-height: 31px;
        font-weight: ${theme.fonts.weights.bold};
    `;

    return (
        <div css={style}>
            {text}
        </div>
    );
};

export default ItemQuantityText;